export const PRICE_OPTIONS = {
  ko: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
  en: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  jp: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
};

// 휴대폰 번호 '-' 구분하는 형식으로 변경
export const formatPhone = (value?: string | number | null): string => {
  if (!value) return "";

  const phoneNumber = value
    .toString()
    .replace(/^\+82/, "0")
    .replace(/[^0-9]/g, "");

  // 서울 지역번호 (02)
  if (phoneNumber.startsWith("02") && phoneNumber.length === 9) {
    return `${phoneNumber.slice(0, 2)}-${phoneNumber.slice(2, 5)}-${phoneNumber.slice(5)}`;
  }

  // 서울 지역번호 (02) - 4자리 국번
  if (phoneNumber.startsWith("02") && phoneNumber.length === 10) {
    return `${phoneNumber.slice(0, 2)}-${phoneNumber.slice(2, 6)}-${phoneNumber.slice(6)}`;
  }

  // 휴대폰 (010, 011, 016, 017, 018, 019)
  if (/^01[016789]/.test(phoneNumber) && phoneNumber.length === 11) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7)}`;
  }

  // 기타 지역번호 (031, 032, 033, 041, 042, 043, 051, 052, 053, 054, 055, 061, 062, 063, 064, 070)
  if (phoneNumber.length === 10 || phoneNumber.length === 11) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, phoneNumber.length === 10 ? 6 : 7)}-${phoneNumber.slice(phoneNumber.length === 10 ? 6 : 7)}`;
  }

  return phoneNumber;
};
